import React from "react";
import "./Testimonies.css";

const Testimonies = () => {
	return (
		<div className='uiowa-testimonies py-5'>
			<div className='content'>
				<div className='left'>
					<h1>Hear from Hawkeyes</h1>
					<p>
						Meet some of our students and find out why Iowa was the right choice for
						them.
					</p>
				</div>
				<div className='right'>
					<div className='item'>Video</div>
					<div className='item'>Video</div>
					<div className='item'>Video</div>
				</div>
			</div>
		</div>
	);
};

export default Testimonies;
